import Vue from 'vue'
import Vuex from 'vuex'
import user from './modules/user'
import asyncRouter from './modules/async-router'
// 时区设置
import timezone from './modules/timezone'
Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    user, // 用户相关状态机
    asyncRouter, // 动态菜单
    timezone // 时区设置
  },
  state: {
    // 定义全局loading 为false
    globalLoading: false
  },
  mutations: {
    // 显示与关闭 全局 loading
    showLoading (state) {
      state.globalLoading = true
    },
    hideLoading (state) {
      state.globalLoading = false
    }
  },
  actions: {

  }
})
